import Doc from '@mdx-js/runtime/readme.md';
import * as React from 'react';
export default {
  Doc,
  React
};